var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    d: "M20.882 20.922L19.395 7.54a1.6 1.6 0 00-1.588-1.421h-.244a5.641 5.641 0 00-11.234 0h-.247A1.6 1.6 0 004.494 7.54L3.005 20.919a1.6 1.6 0 001.588 1.774h14.7a1.6 1.6 0 001.589-1.771zM11.946 2.09a4.559 4.559 0 014.522 4.034H7.423a4.56 4.56 0 014.525-4.034zm4.445 10.229a1.95 1.95 0 00-.212-.012 1.9 1.9 0 00-1.779 2.567 4.67 4.67 0 01-4.908 0 1.9 1.9 0 00-1.779-2.567 1.925 1.925 0 00-.21.012 4.655 4.655 0 011.6-5.106h5.689a4.673 4.673 0 011.601 5.106zm3.282 9.12a.5.5 0 01-.379.169h-14.7a.507.507 0 01-.505-.564L5.578 7.665a.507.507 0 01.505-.452h1.452a5.933 5.933 0 00-.39.521 5.747 5.747 0 00-.65 5.012 1.90019006 1.90019006 0 002.333 3 5.724 5.724 0 003.107.916 5.783 5.783 0 003.123-.918 1.9 1.9 0 002.336-2.994 5.773 5.773 0 00-1.042-5.535h1.452a.507.507 0 01.505.452l1.489 13.379a.5.5 0 01-.123.394z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.1a0d395faedf2683e5dd62990705e2ee.svg";
export { ForwardRef as ReactComponent };